import React from 'react';
import Logo from './Logo';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <Logo size="md" textColor="white" />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              Custom software, cloud infrastructure, and AI-powered tools for businesses across North America
              and Latin America. Bilingual (EN/ES).
            </p>
            <div className="flex gap-3 mt-5">
              <a
                href="https://www.linkedin.com/company/cloudignitesolutions/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-9 h-9 bg-slate-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
                </svg>
              </a>


            </div>
          </div>

          {/* Services links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-widest mb-4">Services</h4>
            <ul className="space-y-2.5">
              {[
                'Custom Software Development',
                'AI-Powered Tools',
                'CRM & Business Systems',
                'Cloud Architecture',
                'DevOps & CI/CD',
                'Cost Optimization',
              ].map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    className="text-slate-400 hover:text-blue-400 text-sm transition-colors duration-200"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-widest mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#about" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">About Us</a>
              </li>
              <li>
                <a href="#contact" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">Contact</a>
              </li>
              <li>
                <a href="#contact" className="text-slate-400 hover:text-blue-400 text-sm transition-colors">Get a Free Quote</a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/cloudignitesolutions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-blue-400 text-sm transition-colors"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 mt-10 pt-8 flex flex-col sm:flex-row justify-center items-center gap-4">
          <p className="text-slate-500 text-sm mb-4">
            &copy; {year} CloudIgnite. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
